export default __webpack_public_path__ + "tiktok-sqr-v1.svg";